import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { CellButton, CellButtons } from '../CellButton';
import { PerformActionButton } from '../PerformActionButton';
import { View } from '../../../../components/Icon';
import { Loader } from '../../../../components/Loader';
import dayjs from 'dayjs';
import { VehicleHeader } from '../../../Vehicles/components/VehicleHeader';
import ModalComponent from '../../../../containers/App/Components/Modal/Modal';
import { WithVehicle } from '../../../Vehicles/components/WithVehicle';
import { HBox, VBox } from '../../../../components/Box';
import { Row } from '../../../../components/List';
import { Cell } from '../Cell';
import ButtonComponent from '../../../../containers/App/Components/Button/Button';
import { KanbanVehicleRemarks } from '../../components/KanbanVehicleRemarks';
import { DoubleCheck } from '../../../../containers/App/Components/DoubleCheck/DoubleCheck';
import { VehicleEditableField } from '../../../Vehicles/components/VehicleEditableField';
import { BaseCellComp } from '../BaseCellComp';
import customParseFormat from 'dayjs/plugin/customParseFormat';

import { performAction } from '../../actions';
import { selectVehicle } from '../../../Vehicles/selectors';
import { selectUserId, selectWork, selectWorks } from '../../../Api/selectors';
import { REQUEST_KANBAN_BOARD_PERFORM_ACTION } from '../../constants';
import { REQUEST_VEHICLE_PROPERTY_UPDATE } from '../../../Vehicles/constants';
import { getRemarkType } from '../helpers/getRemarkType';

import styles from './Hooi_Default.module.css';
import { VehiclePhotoUploader } from '../../../Vehicles/components/VehiclePhotoUploader';
import { Label } from '../../../Vehicles/components/VehicleCounterLabel';

dayjs.extend(customParseFormat);

const ranges = {
  MediumSeaGreen: [2, 4],
  DarkOrange: [5, 29],
  Crimson: [30, Infinity],
};
 

const TASK_REMARK_TYPE = 'HOOI_NEW_task_store_personal_belongings';
const Container = styled.div`
  .modal-inner {
  }

  .manco-list > div {
  }
`;

const STATE = {
  approve: false,
  regplate_code: '',
};

/* eslint-disable react/prefer-stateless-function */
class HOOI_NEW_store_personal_belongingsComp extends BaseCellComp {
  constructor(props) {
    super(props, { ...STATE });
  }

  componentDidMount() {}


  dateDifference(date_of_arrival) {
    const createdDate = date_of_arrival || this.propertyValue('date_of_arrival');
    if (!createdDate) return 0;
  
    const now = dayjs();
    const created = dayjs(createdDate, 'DD-MM-YYYY'); // <-- correct parse format
  
    if (!created.isValid()) return 0;
  
    const diff = now.diff(created, 'day');
    return diff;
  }
  componentDidUpdate(prevProps, prevState) {}

  get vehicle() {
    return this.props.cell.vehicle;
  }
  get doubleCheckProps() {
    return [
      'personal_belongings_more_than_one_create',

      // 'HOOI_NEW_print_label_and_store_belongings',

      // 'HOOI_NEW_sent_message_to_client_belongings',
    ];
  }

  get inputFields() {
    return ['HOOI_NEW_number_of_crates_belonings', 'HOOI_NEW_m2_belonings'];
  }

  // get dateFields() {
  //   return ['date_of_arrival', 'date_removed'];
  // }

  reset() {
    this.setState({ ...STATE });
  }

  confirm() {
    //apprive BVI ...
    this.props.confirm(this.vehicle.id, this.state.regplate_code);
  }

  propertyValue(name) {
    return this.props.vehicle[name];
  }


disableConfirmation() {
  const PHOTO_TYPE = 'HOOI_NEW_store_personal_belongings';

  // If removed date is set but no pickup/disposal choice, still block
  if (
    this.propertyValue('date_removed') &&
    !this.propertyValue('HOOI_NEW_belongings_disposed_or_pickedup')
  ) {
    return true;
  }

  const assets = [
    ...(this.props.vehicle?.documents ?? []),
    ...(this.props.vehicle?.photos ?? []),
    ...(this.vehicle?.documents ?? []),
    ...(this.vehicle?.photos ?? []),
  ];

  // Helpful logging
  console.log(
    '[disableConfirmation] assets:',
    assets.map((p, idx) => ({
      index: idx,
      keys: Object.keys(p || {}),
      name: p?.name,
      type: p?.type,
      photoType: p?.photoType,
      photo_type: p?.photo_type,
      tags: p?.tags,
    }))
  );

  const belongsToTask = (p) => {
    const t = p?.type || p?.photoType || p?.photo_type || '';
    return (
      t === PHOTO_TYPE ||
      t?.endsWith(`_${PHOTO_TYPE}`) ||           // matches "<index>_<type>"
      p?.name === PHOTO_TYPE ||                  // some backends store the label in name
      (Array.isArray(p?.tags) && p.tags.includes(PHOTO_TYPE))
    );
  };

  const belongingsPhotos = assets.filter(belongsToTask);

  console.log('[disableConfirmation] belongingsPhotos:', belongingsPhotos);

  return belongingsPhotos.length === 0;
}

  renderApprove() {
    if (!this.state.approve) return null;

    return (
      <ModalComponent onClose={this.reset.bind(this)} title={this.props.column.label}>
        <WithVehicle loader vehicle_id={this.vehicle.id}>
          <div className="mb-2">
            <VehicleHeader vehicle={this.vehicle} hooikammer kanbanCell HOOI_NEW_belongings_in />
          </div>

          <Container>
            <VBox className="manco-list" key="manco">
              {this.doubleCheckProps.map(name => {
                return (
                  <Row key={name}>
                    <Cell>
                      <DoubleCheck key={name} name={name} vehicle={this.props.vehicle} />
                    </Cell>
                  </Row>
                );
              })}

              {/* <Row key={'personal_belongings_more_than_one_create'}>
                <Cell>
                  <DoubleCheck
                    key={'personal_belongings_more_than_one_create'}
                    name={'personal_belongings_more_than_one_create'}
                    vehicle={this.props.vehicle}
                  />
                </Cell>
              </Row> */}
              {this.propertyValue('personal_belongings_more_than_one_create') == '1' && (
                <Row key={'personal_belongings_more_than_one_create_status'}>
                  <Cell>
                    <DoubleCheck
                      key={'personal_belongings_more_than_one_create_status'}
                      name={'personal_belongings_more_than_one_create_status'}
                      vehicle={this.props.vehicle}
                    />
                  </Cell>
                </Row>
              )}
              {(this.propertyValue('personal_belongings_more_than_one_create') == '0' ||
                this.propertyValue('personal_belongings_more_than_one_create') == '1') && (
                <>
                  <Cell>Maak foto van spullen</Cell>
                  <Row key={'HOOI_NEW_store_personal_belongings_photo'}>
                    <VehiclePhotoUploader
                      vehicle={this.props.vehicle}
                      photoType={'HOOI_NEW_store_personal_belongings'}
                      photoIndex={'photo_hooi_hooi_instalation'}
                    />
                  </Row>
                  <Row key={'personal_belongings_print_label'}>
                    <Cell>
                      <DoubleCheck
                        key={'personal_belongings_print_label'}
                        name={'personal_belongings_print_label'}
                        vehicle={this.props.vehicle}
                      />
                    </Cell>
                  </Row>

                  {/* <Row key={'personal_belongings_store_on_shelf'}>
                    <Cell>
                      <DoubleCheck
                        key={'personal_belongings_store_on_shelf'}
                        name={'personal_belongings_store_on_shelf'}
                        vehicle={this.props.vehicle}
                      />
                    </Cell>
                  </Row> */}
                  <Row key={'personal_belongings_message_sent_to_client_contact'}>
                    <Cell>
                      <DoubleCheck
                        key={'personal_belongings_message_sent_to_client_contact'}
                        name={'personal_belongings_message_sent_to_client_contact'}
                        vehicle={this.props.vehicle}
                      />
                    </Cell>
                  </Row>
                </>
              )}

              {this.propertyValue('personal_belongings_more_than_one_create') == '1' && (
                <>
                  <Row key={'HOOI_NEW_number_of_crates_belonings'}>
                    <Cell>
                      <VehicleEditableField name={'HOOI_NEW_number_of_crates_belonings'} vehicle={this.props.vehicle} />
                    </Cell>
                  </Row>
                  <Row key={'HOOI_NEW_m2_belonings'}>
                    <Cell>
                      <VehicleEditableField name={'HOOI_NEW_m2_belonings'} vehicle={this.props.vehicle} />
                    </Cell>
                  </Row>
                </>
              )}

              <Row key={'date_of_arrival'}>
                <Cell>
                  <VehicleEditableField name={'date_of_arrival'} vehicle={this.props.vehicle} inputType={'date'} />
                </Cell>
              </Row>

            
              <Row key={'HOOI_NEW_belongings_disposed_or_pickedup'}>
                <Cell>
                  <DoubleCheck
                    key={'HOOI_NEW_belongings_disposed_or_pickedup'}
                    name={'HOOI_NEW_belongings_disposed_or_pickedup'}
                    vehicle={this.props.vehicle}
                    customYes={'Opgehaald'}
                    customNo={'Afgevoerd'}
                  />
                </Cell>
              </Row>

              {(this.propertyValue('HOOI_NEW_belongings_disposed_or_pickedup') == '1' || this.propertyValue('HOOI_NEW_belongings_disposed_or_pickedup') == '0' ) && (
              <Row key={'date_removed'}>
                <Cell>
                  <VehicleEditableField name={'date_removed'} vehicle={this.props.vehicle} inputType={'date'} />
                </Cell>
              </Row>
              )}
              <HBox className="mt-3">
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    key={'modal'}
                    fullWidth={true}
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
              </HBox>
            </VBox>
          </Container>
        </WithVehicle>
        <div className="d-flex gap-2 mt-3">
          <PerformActionButton
            disabled={this.disableConfirmation()}
            className={styles.confirmButton}
            action={this.props.action}
            target={this.vehicle}
            onChange={this.reset.bind(this)}
          />

          <ButtonComponent style={'ButtonSoftDelete'} onClick={this.reset.bind(this)}>
            {this.lbl('cancel')}
          </ButtonComponent>
        </div>
      </ModalComponent>
    );
  }

  render() {
    const vehicle = this.vehicle;
    if (!vehicle) return <Loader />;
  
    const arrivalDate = vehicle?.date_of_arrival || dayjs();
    const days = this.dateDifference(arrivalDate);
    return (
      <Cell>
        <Container>
          <VehicleHeader vehicle={vehicle} kanbanCell HOOI_NEW_belongings_in />
          <Label count={days} ranges={ranges}>
            {days}
          </Label>
          <CellButtons>
            {this.props.cell.busy ? (
              <Loader small />
            ) : (
              <>
                {this.props.workRemarks ? (
                  <Loader small />
                ) : (
                  <KanbanVehicleRemarks
                    readOnly
                    taskName={TASK_REMARK_TYPE}
                    kanbanBoardLabel={this.props.board?.label}
                    vehicleId={this.vehicle.id}
                    loggedUserId={this.props.loggedInUserId}
                  />
                )}
                <CellButton
                  onClick={this.setStateFn({ approve: !this.state.approve, regplate_code: vehicle.regplate_code || '' })}
                >
                  <View />
                </CellButton>
              </>
            )}
          </CellButtons>
        </Container>
        {this.renderApprove()}
      </Cell>
    );
  }
}

HOOI_NEW_store_personal_belongingsComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    work: selectWorks([`${REQUEST_KANBAN_BOARD_PERFORM_ACTION + ownProps.actionId}_${ownProps.cell.vehicle?.id}`]),
    vehicle: selectVehicle(ownProps.cell.vehicle.id),
    loggedInUserId: selectUserId(),
    workRemarks: selectWork(`${REQUEST_VEHICLE_PROPERTY_UPDATE}-${getRemarkType(TASK_REMARK_TYPE)}`),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    confirm(vehicle_id, regplate_code) {
      dispatch(performAction(ownProps.action.id, vehicle_id, { regplate_code }));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const HOOI_NEW_store_personal_belongings = compose(withConnect, withRouter)(HOOI_NEW_store_personal_belongingsComp);
